<template>
    <div>
        <div class="padding-horizontal-large">
            <div class="title__header">
                <span class="helper__tooltip purple">
                    <h3>{{t.car_bonus_points}}</h3>
                    <span class="helper__tooltip--text" v-html="t.car_bonus_prediction"></span>
                </span>
            </div>
            <div class="d-f">
                <div
                    class="card__grey"
                >
                    <div
                        v-bind:class="{ 'top': showCarBonusActiveLeads, 'top no-border-bottom': !showCarBonusActiveLeads }"
                    >
                        <div class="header">
                            <h2 v-html="t.label_car_bonus_points"></h2>
                            <h2>{{pointsOldCardGrey}}</h2>
                        </div>
                        <span v-html="t.label_car_bonus_points_text"></span>
                    </div>
                    <div class="bottom" v-if="showCarBonusActiveLeads">
                        <div class="header">
                            <h2 v-html="t.label_car_bonus_active_leads"></h2>
                            <h2>{{pointsNewCardGrey}}</h2>
                        </div>
                        <span v-html="t.label_car_bonus_active_leads_text"></span>
                    </div>
                </div>

                <div class="car__bonus__out">
                    <div class="car__bonus__in d-f">
                        <div class="flex-2">
                            <div class="values">
                                <span :style="{ left: 0 + '%' }">{{t.points}}</span>
                                <span :style="{ left: 9.09 + '%' }">690</span>
                                <span :style="{ left: 18.18 + '%' }">1380</span>
                                <span :style="{ left: 27.27 + '%' }">2070</span>
                                <span :style="{ left: 36.36 + '%' }">2760</span>
                                <span :style="{ left: 45.45 + '%' }">3450</span>
                                <span :style="{ left: 54.54 + '%' }">4140</span>
                                <span :style="{ left: 63.63 + '%' }">4830</span>
                                <span :style="{ left: 72.72 + '%' }">5520</span>
                                <span :style="{ left: 81.81 + '%' }">6210</span>
                                <span :style="{ left: 90.90 + '%' }">6900</span>
                            </div>
                            <div class="loading__out">
                                <div class="loading__bar">
                                    <div
                                        class="bar_new"
                                        v-if="pointsNew > 0"
                                        :style="{ width: pointsNew + '%'}"
                                    >
                                        <b>{{pointsNewStatic}}</b>
                                        <span
                                            v-html="pointsNewStatic + ' - ' + t.prediction_new_points"
                                        ></span>
                                    </div>
                                    <div
                                        class="bar_old"
                                        v-if="pointsOld > 0"
                                        :style="{ width: ((pointsOld - pointsNew) > pointsNew ? (100 - pointsNew) : (pointsOld - pointsNew)) + '%', left: pointsNew + '%' }"
                                    >
                                        <b>{{pointsOldStatic}}</b>
                                        <span
                                            v-html="pointsOldStatic + ' - ' + t.prediction_old_points"
                                        ></span>
                                    </div>
                                </div>
                                <!-- <span class="total__points__mob">{{maxValue}}</span> -->
                            </div>
                            <div class="values">
                                <span :style="{ left: 0 + '%' }">{{t.paid}}</span>
                                <span :style="{ left: 9.09 + '%' }">{{this.simbol + this.rangeValue[0]}}</span>
                                <span
                                    :style="{ left: 18.18 + '%' }"
                                >{{this.simbol + this.rangeValue[1]}}</span>
                                <span
                                    :style="{ left: 27.27 + '%' }"
                                >{{this.simbol + this.rangeValue[2]}}</span>
                                <span
                                    :style="{ left: 36.36 + '%' }"
                                >{{this.simbol + this.rangeValue[3]}}</span>
                                <span
                                    :style="{ left: 45.45 + '%' }"
                                >{{this.simbol + this.rangeValue[4]}}</span>
                                <span
                                    :style="{ left: 54.54 + '%' }"
                                >{{this.simbol + this.rangeValue[5]}}</span>
                                <span
                                    :style="{ left: 63.63 + '%' }"
                                >{{this.simbol + this.rangeValue[6]}}</span>
                                <span
                                    :style="{ left: 72.72 + '%' }"
                                >{{this.simbol + this.rangeValue[7]}}</span>
                                <span
                                    :style="{ left: 81.81 + '%' }"
                                >{{this.simbol + this.rangeValue[8]}}</span>
                                <span
                                    :style="{ left: 90.90 + '%' }"
                                >{{this.simbol + this.rangeValue[9]}}</span>
                            </div>
                        </div>
                        <div class="info__value">
                            <img src="/internacional/public/office4/img/franchise/car-bonus/badge.svg" />
                            <span>{{this.simbol + realValue}}</span>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
export default {
    name: "car-bonus",
    components: {},
    data() {
        return {
            t: this.$parent.view.translation.car_bonus,
            ico: null,
            simbol: null,
            rangeValue: [],
            valueToBlur: null,
            pointsStatic: 0,
            points: 0,
            maxValue: 0,
            maxPoints: 6900,
            pointsOld: 0,
            pointsOldStatic: 0,
            pointsNew: 0,
            pointsNewStatic: 0,
            pointsOldCardGrey: 0,
            pointsNewCardGrey: 0,
            realValue: 0,
            showCarBonusActiveLeads: false
        };
    },
    methods: {},
    mounted() {
        this.type = this.$parent.view.dashboard_values_v4.car_bonus.type;
        this.simbol = this.$parent.view.dashboard_values_v4.car_bonus.simbol;
        this.realValue = this.$parent.view.dashboard_values_v4.car_bonus.value;
        this.valueToBlur = this.$parent.view.dashboard_values_v4.car_bonus.valueToBlur;
        this.pointsOldCardGrey = this.$parent.view.dashboard_values_v4.car_bonus.total_points;
        this.pointsNewCardGrey = this.$parent.view.dashboard_values_v4.car_bonus.active_leads;
        this.showCarBonusActiveLeads = this.$parent.view.dashboard_values_v4.car_bonus.show_car_bonus_active_leads;
        this.pointsStatic = this.$parent.view.dashboard_values_v4.car_bonus.points;
        this.points = this.$parent.view.dashboard_values_v4.car_bonus.points;
        this.pointsOld = this.$parent.view.dashboard_values_v4.car_bonus.points_old;
        this.pointsOldStatic = this.$parent.view.dashboard_values_v4.car_bonus.points_old;
        // this.pointsOld        = 8887; //local-test
        // this.pointsOldStatic  = 8887; //local-test
        this.pointsNew = this.$parent.view.dashboard_values_v4.car_bonus.points_new;
        this.pointsNewStatic = this.$parent.view.dashboard_values_v4.car_bonus.points_new;
        // this.pointsNew        = 1825; //local-test
        // this.pointsNewStatic  = 1825; //local-test
        if (this.points > this.maxPoints) this.points = this.maxPoints;
        this.points = (this.points * 100) / this.maxPoints;
        this.pointsOld = (this.pointsOld * 100) / this.maxPoints;
        this.pointsNew = (this.pointsNew * 100) / this.maxPoints;

        //range values
        if (this.type == "USD") {
            this.maxValue = 500;
            this.rangeValue = [50, 100, 150, 200, 250, 300, 350, 400, 450, 500];
        }
        if (this.type == "BRL") {
            this.maxValue = 1000;
            this.rangeValue = [
                100,
                200,
                300,
                400,
                500,
                600,
                700,
                800,
                900,
                1000
            ];
        }
        if (this.type == "EUR") {
            this.maxValue = 425;
            this.rangeValue = [
                42.5,
                85,
                127.5,
                170,
                212.5,
                255,
                297.5,
                340,
                382.5,
                425
            ];
        }

        //blur value
        if (this.valueToBlur >= 0) {
            //get all elements
            let allValues = document.querySelectorAll(".values > span");
            for (let i = 0; i < allValues.length; i++) {
                //if the element in the row is the one passed by props will add the blured style
                if (this.valueToBlur == i) allValues[i].classList.add("blured");
            }
        }
    }
};
</script>
<style scoped lang="scss">
h2 {
    font-family: "Muli";
    font-weight: bold;
    font-size: 18px;
    line-height: 23px;
    color: #707070;
}
.b-g {
    border: 1px solid #dadada;
    border-radius: 8px;
    padding: 1rem 0 2rem .3rem;
}
.d-f {
    display: flex;
    align-items: center;
    .flex-2 {
        flex: 2;
    }
    .card__grey {
        flex: 0 0 190px;
        background: rgba(237, 240, 245, 0.5);
        border: 1px solid #dadada;
        padding: 0.4rem 0.4rem;
        margin-right: .5rem;
        border-radius: 7px;
        &.m-t-4rem {
            margin-top: 4rem;
        }
        .top,
        .bottom {
            .header {
                display: flex;
                align-items: center;
                h2 {
                    font-size: 1.4rem;
                    &:first-child {
                        margin-top: 0.4rem;
                    }
                    &:last-child {
                        color: #0cad25;
                    }
                }
            }
            span {
                font-size: 0.8rem;
            }
        }
        .top {
            position: relative;
            margin-bottom: 2rem;
            &::before {
                content: "";
                position: absolute;
                bottom: -10px;
                width: 75%;
                height: 1px;
                left: 0;
                right: 0;
                background: #dadada;
                margin: 0 auto;
            }
            &.no-border-bottom::before {
                content: none;
            }
        }
    }
    .car__bonus__out {
        flex: 0 0 calc(100% - 210px);
    }
}
.info__value {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    padding: 0 1rem;
    text-align: center;
    span {
        color: #0cad25;
        font-weight: bold;
        margin-top: 1.7rem;
    }
}
.title__header {
    background: white;
    text-align: center;
    padding: 1rem 0;
    span {
        font-weight: bold;
    }
}
.points__header {
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    h2 {
        margin: 0;
    }
    span {
        color: #0294ff;
        font-weight: bold;
        font-size: 1.5rem;
        line-height: 0.9;
    }
}
@mixin spanBar {
    span {
        font-size: 0.9rem;
        font-weight: bold;
        position: absolute;
        left: 0;
        right: 0;
        margin: 0 auto;
        bottom: -23px;
        background-color: white;
        width: 280px;
        padding: 0 0.4rem;
        z-index: 999;
        transition: 0.5s all;
        color: var(--theme-color-accent);
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 4px;
    }
}
.car__bonus {
    border-radius: 0 0 7px 7px;
    border: 1px solid #c6c6c6;
    padding: 0 2rem 1rem 2rem;
    margin-bottom: 2rem;
    background: white;
}
.car__bonus__out {
    display: flex;
    flex-direction: column;
    .car__bonus__in {
        padding: 3rem 0 3rem .5rem;
        border-radius: 7px;
        margin: 0;
        border: 1px solid #c6c6c6;
        font-family: "Muli";
        .loading__out {
            .loading__bar {
                width: 100%;
                height: 19px;
                border-radius: 7px;
                margin: 1.5rem 0;
                border: 1px solid #c6c6c6;
                position: relative;
                .bar_new {
                    position: absolute;
                    color: white;
                    font-weight: bold;
                    font-size: 0.9rem;
                    padding: 1px 0 0 10px;
                    border-radius: 7px 0 0 7px;
                    position: absolute;
                    height: 17px;
                    background: var(--theme-color-accent);
                    @include spanBar();
                    b {
                        font-size: 0.7rem;
                    }
                    &:hover {
                        span {
                            display: block;
                        }
                    }
                }
                .bar_old {
                    position: absolute;
                    color: white;
                    font-weight: bold;
                    font-size: 0.9rem;
                    padding: 1px 0 0 10px;
                    border-radius: 0 7px 7px 0;
                    height: 17px;
                    background: #b286e9;
                    @include spanBar();
                    b {
                        font-size: 0.7rem;
                    }
                    &:hover {
                        span {
                            display: block;
                        }
                    }
                }
            }
            span {
                display: none;
            }
        }
        .segment {
            display: flex;
            justify-content: space-around;
            align-items: center;
        }
        .values {
            position: relative;
            height: 16px;
            span {
                position: absolute;
                font-weight: bold;
                color: #707070;
            }
            .blured {
                color: transparent;
                text-shadow: 0 0 5px rgba(0, 0, 0, 0.5);
                -webkit-touch-callout: none;
                -webkit-user-select: none;
                -khtml-user-select: none;
                -moz-user-select: none;
                -ms-user-select: none;
            }
            .value__responsive {
                display: none;
            }
        }
    }
}
@media (max-width: 1300px) {
    .card__grey {
        margin-right: 0 !important;
        padding: 0.4rem 1rem;
        .header {
            justify-content: space-between;
            align-items: center;
        }
    }
    .info__value {
        margin-bottom: 0.8rem;
    }
    .points__header span {
        margin: 0.5rem 0;
    }
    .d-f {
        flex-direction: column;
        align-items: unset;
    }
}
@media (max-width: 900px) {
    .separator,
    .points__header {
        display: none;
    }
    .car__bonus {
        .segment img {
            display: none;
        }
        .img__responsive {
            display: block;
            animation: driveByIcons 5s linear infinite;
            background-repeat: no-repeat;
            width: 150px;
            height: 100px;
            background-size: 100%;
        }
        .values {
            span {
                display: none;
            }
            .value__responsive {
                display: block;
                margin-top: 1rem;
            }
        }
    }
    .loading__out {
        display: flex;
        align-items: flex-end;
        justify-content: space-evenly;
        .loading__bar {
            width: 80%;
            margin: 0 !important;
        }
        span.total__points__mob {
            display: block !important;
            color: #0294ff;
            font-weight: bold;
            margin: 0 0 0 1rem;
        }
    }
}
@keyframes driveByIcons {
    0% {
        background-image: url("/internacional/public/office3/img/franchise/car-bonus/ic-scooter-on.svg");
    }
    25% {
        background-image: url("/internacional/public/office3/img/franchise/car-bonus/ic-bike-off.svg");
    }
    50% {
        background-image: url("/internacional/public/office3/img/franchise/car-bonus/ic-car-motorcycle-off.svg");
    }
    75% {
        background-image: url("/internacional/public/office3/img/franchise/car-bonus/ic-car-beetle-off.svg");
    }
    100% {
        background-image: url("/internacional/public/office3/img/franchise/car-bonus/ic-car-off.svg");
    }
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/franchise_v4/rank/components/carBonus.vue